/* eslint-disable max-len */
import React from 'react';
import { node, shape, string } from 'prop-types';

import { getGridClasses } from '../utils/ui';
import { LAUNDRY_GRID_BASE } from '../constants/index';

const LaundryProductsLayout = ({ children, grid, className, element }) => {
  const gridClasses = getGridClasses(grid);
  const HTMLTag = typeof element === 'string' ? element : 'div';
  return (
    <HTMLTag
      className={`sui-relative sui-flex sui-flex-col sui-items-center ${LAUNDRY_GRID_BASE} ${gridClasses} ${className}`}
    >
      {children}
    </HTMLTag>
  );
};

LaundryProductsLayout.propTypes = {
  children: node.isRequired,
  grid: shape({}),
  className: string,
  element: string
};

LaundryProductsLayout.defaultProps = {
  grid: null,
  className: '',
  element: 'div'
};

export default LaundryProductsLayout;